export const CHARTER_QUESTIONS: Array<{
    key: 'opportunity' | 'purpose' | 'success' | 'metric' | 'kit' | 'roles' | 'timeline'
    label: string
}> = [
    { key: 'opportunity', label: '1. What opportunity or challenge is this team for?' },
    { key: 'purpose', label: '2. Purpose, in one phrase or a short paragraph' },
    { key: 'success', label: '3. What does success look like?' },
    { key: 'metric', label: '4. How will we measure it? Which KPIs, each with a target?' },
    { key: 'kit', label: '5. What skills, tools, models, and assets does it need?' },
    { key: 'roles', label: '6. Which roles?' },
    { key: 'timeline', label: '7. What is the timeline?' },
]
